import { SortableFilter }          from './../common/sortable-filter';

export class TrainSortableFilter extends SortableFilter {
    public enabledOnly = true;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-list/train-sortable-filter.ts